var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"tunedScrollBar",staticStyle:{"overflow-y":"auto","height":"100%"}},[_c('ul',{staticClass:"tree_view v-list--dense"},[_c('tree-node-view',{key:_vm.model.update_ind,attrs:{"model":_vm.model,"hideProps":_vm.hideProps}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }